import { createContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { MatchParam } from "src/constants/matches";

export const PreferredLanguageContext = createContext<string | null>(null);

interface Props {
  children: React.ReactNode;
}

const PreferredLanguageProvider = ({ children }: Props) => {
  const { language } = useParams<MatchParam<"LANGUAGE">>();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (language != null) {
      i18n.changeLanguage(language);
    }
  }, [i18n, language]);

  return (
    <PreferredLanguageContext.Provider value={i18n.language}>
      {children}
    </PreferredLanguageContext.Provider>
  );
};

export default PreferredLanguageProvider;
